var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.href
    ? _c(
        "a",
        {
          staticClass: "button",
          class: { disabled: _vm.disabled },
          style: _vm.style,
          attrs: { href: _vm.href }
        },
        [_c("span", { staticClass: "inner centered" }, [_vm._t("default")], 2)]
      )
    : _c(
        "button",
        {
          staticClass: "button",
          class: { disabled: _vm.disabled },
          style: _vm.style,
          attrs: { disabled: _vm.disabled }
        },
        [_c("span", { staticClass: "inner centered" }, [_vm._t("default")], 2)]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }